import SOUP_ICON from "../icons/soup.png";
import BRAISED_ICON from "../icons/braised.png";
import SEASONED_ICON from "../icons/seasoned.png";
import STIR_FRY_ICON from "../icons/stirfry.png";
import STEAMED_ICON from "../icons/steamed.png";

export const categoryIcons = {
  SOUP: SOUP_ICON,
  BRAISED: BRAISED_ICON,
  SEASONED: SEASONED_ICON,
  STIR_FRY: STIR_FRY_ICON,
  STEAMED: STEAMED_ICON,
};